// extracted by mini-css-extract-plugin
export default {"comingSoonContainer":"style_comingSoonContainer__Z3cv2","highlight":"style_highlight__rjl8L","notify":"style_notify__rX+Np","callText":"style_callText__hmkV6"};